import _ from "lodash";

/**
 * Converts a given string to sentence case.
 *
 * This function takes an input string, converts it to lowercase, and then
 * capitalizes the first letter of the first word. All underscores are replaced
 * with spaces during this process.
 *
 * @param {string} str - The input string to be converted.
 * @returns {string} - The input string converted to sentence case.
 *                     Returns an empty string if the input is null or undefined.
 *
 * @example
 * toSentenceCase('FLEXIBLE');
 * // returns 'Flexible'
 *
 * @example
 * toSentenceCase('NON_REFUNDABLE');
 * // returns 'Non refundable'
 */
const toSentenceCase = (str) => {
  if (!str) return str;
  return _.lowerCase(str).charAt(0).toUpperCase() + _.lowerCase(str).slice(1);
};

export default toSentenceCase;
